export class LinkItem {
  constructor(public title: string, public href?: string, public callback?: () => void) {}
}
